import React from 'react'
import { BsFillTrashFill } from "react-icons/bs"
import { Row, Col} from "react-bootstrap"
import { withTranslation } from 'react-i18next'
import {canEditDoctor} from "../../utils/isDoctor";

const ItemMedicamento = ({ t, position, item, handleDeleteMedicamento, readOnly, isColombia = false, cita, auth }) => {
    return (
        <div className='item-medicamento-container'>
            <Row className='item-medicamento'>
                <Col xs={10}>
                    <span className='font-weight-bold font-size-08rem mb-1 text-secondary text-first-up'>
                        {isColombia ? "Principio Activo (Nombre Comercial)" : t('medicamento')}: 
                    </span><span className='font-size-08rem mb-1 text-secondary'>{item?.medicamento}</span><br/>
                    {isColombia && (
                        <>
                            <span className='font-weight-bold font-size-08rem mb-1 text-secondary text-first-up'>Concentracion: </span><span className='font-size-08rem mb-1 text-secondary'>{item?.gramaje}</span><br />
                        </>
                    )}
                    <span className='font-weight-bold font-size-08rem mb-1 text-secondary text-first-up'>
                        {isColombia ? "Forma Farmaceutica (Presentacion)" : t('presentacion')}: 
                    </span><span className='font-size-08rem mb-1 text-secondary'>{item?.presentacion}</span><br />
                    <span className='font-weight-bold font-size-08rem mb-1 text-secondary text-first-up'>
                        {isColombia ? "Via de administracion" : t('administracion')}: 
                    </span><span className='font-size-08rem mb-1 text-secondary'>{item?.administracion}</span><br />
                    <span className='font-weight-bold font-size-08rem mb-1 text-secondary text-first-up'>{t('dosis')}: </span><span className='font-size-08rem mb-1 text-secondary'>{item?.dosis}</span><br />
                    <span className='font-weight-bold font-size-08rem mb-1 text-secondary text-first-up'>
                        {isColombia ? "¿Cada Cuantas Horas?" : t('horas')}: 
                    </span> <span className='font-size-08rem mb-1 text-secondary'>{item?.horas}</span><br />
                    <span className='font-weight-bold font-size-08rem mb-1 text-secondary text-first-up'>{t('dias')}: </span><span className='font-size-08rem mb-1 text-secondary'>{item?.dias}</span> <br />
                    {isColombia && (
                        <>
                            <span className='font-weight-bold font-size-08rem mb-1 text-secondary text-first-up'>Total De Unidades Requeridas: </span> <span className='font-size-08rem mb-1 text-secondary'>{item?.cantidad}</span><br />
                        </>
                    )}
                    <span className='font-weight-bold font-size-08rem mb-1 text-secondary text-first-up'>{t('indicaciones')}: </span><span className='font-size-08rem mb-1 text-secondary'>{item?.indicaciones}</span><br />
                </Col>
                {!readOnly && canEditDoctor(cita, auth) && <Col>
                    <br/>
                    <BsFillTrashFill className='clicked colorRojo' onClick={ () => handleDeleteMedicamento(position) } />
                </Col>}
            </Row>
        </div>
    )
}
export default withTranslation()(ItemMedicamento)